namespace Matrix.Scheduling {
    export class CalendarBaseColumns {
        static columnsKey = 'Scheduling.CalendarBase';
    }
}
